import SystemEnum from '@/assets/js/systemEnum'
import DataType from '@/util/dataType'
const WORK_QUEUE = SystemEnum.WORK_QUEUE_ENUM
const QUEUE = [
  {
    status: WORK_QUEUE.PENDING_IN_HOUSE_APPROVE.value,
    title: WORK_QUEUE.PENDING_IN_HOUSE_APPROVE.text,
    key: WORK_QUEUE.PENDING_IN_HOUSE_APPROVE.key,
    features: WORK_QUEUE.PENDING_IN_HOUSE_APPROVE.features,
    code: DataType.PrivilegeCode.PENDING_IN_HOUSE_APPROVE,
    color: ['indigo lighten-3', '#5C6BC0'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.PENDING_OUT_HOUSE_COLLECTION.value,
    title: WORK_QUEUE.PENDING_OUT_HOUSE_COLLECTION.text,
    key: WORK_QUEUE.PENDING_OUT_HOUSE_COLLECTION.key,
    features: WORK_QUEUE.PENDING_OUT_HOUSE_COLLECTION.features,
    code: DataType.PrivilegeCode.PENDING_OUT_HOUSE_COLLECTION,
    color: ['cyan lighten-3', '#00BCD4'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.OUT_HOUSE_COLLECTION.value,
    title: WORK_QUEUE.OUT_HOUSE_COLLECTION.text,
    key: WORK_QUEUE.OUT_HOUSE_COLLECTION.key,
    features: WORK_QUEUE.OUT_HOUSE_COLLECTION.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_COLLECTION,
    color: ['teal lighten-3', '#009688'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.OUT_HOUSE_PAID_OFF.value,
    title: WORK_QUEUE.OUT_HOUSE_PAID_OFF.text,
    key: WORK_QUEUE.OUT_HOUSE_PAID_OFF.key,
    features: WORK_QUEUE.OUT_HOUSE_PAID_OFF.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_PAID_OFF,
    color: ['lime lighten-4', '#CDDC39'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.OUT_HOUSE_REJECTED.value,
    title: WORK_QUEUE.OUT_HOUSE_REJECTED.text,
    key: WORK_QUEUE.OUT_HOUSE_REJECTED.key,
    features: WORK_QUEUE.OUT_HOUSE_REJECTED.features,
    code: DataType.PrivilegeCode.OUT_HOUSE_REJECTED,
    color: ['amber lighten-3', '#FFC107'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.PENDING_CANCELLATION.value,
    title: WORK_QUEUE.PENDING_CANCELLATION.text,
    key: WORK_QUEUE.PENDING_CANCELLATION.key,
    features: WORK_QUEUE.PENDING_CANCELLATION.features,
    code: DataType.PrivilegeCode.PENDING_CANCELLATION,
    color: ['deep-orange lighten-2', '#D84315'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.CANCELLATION.value,
    title: WORK_QUEUE.CANCELLATION.text,
    key: WORK_QUEUE.CANCELLATION.key,
    features: WORK_QUEUE.CANCELLATION.features,
    code: DataType.PrivilegeCode.CANCELLATION,
    color: ['brown lighten-3', '#795548'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  }
]
export default QUEUE
